import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useCustomizationStore = create()(
    persist(
        (set) => ({
            refetchCustomization: false,
            storeRefetchCustomization: (value) => set({ refetchCustomization: value }),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query }))
        }),
        {
            name: 'customization-storage'
        }
    )
);

export default useCustomizationStore;